import { ActionTypesScreen6 } from "app/constants";

export const defaultState = {
  listData: [],
  objectData: {},
  singleData: null,
};

function Screen6Reducer(state = defaultState, action) {
  switch (action.type) {
    case ActionTypesScreen6.GET_AVERAGE_DATA_SCREEN6:
      return { ...state, averageDataScreen6: action.payload };
    case ActionTypesScreen6.GET_EDUCATION_SUMMARY_DATA_SCREEN6:
      return { ...state, educationSummaryDataScreen6: action.payload };
    case ActionTypesScreen6.GET_EDUCATION_ATTAINMENT_DATA_SCREEN6:
      return { ...state, educationAttainmentDataScreen6: action.payload };
    case ActionTypesScreen6.GET_CTE_FILTER_DATA_SCREEN6:
      return { ...state, cteFilterDataScreen6: action.payload };
    case ActionTypesScreen6.GET_CTE_BAR_CHART_SCREEN6:
      return { ...state, cteBarChartDataScreen6: action.payload };
    case ActionTypesScreen6.GET_CTE_LEFT_SUNBURST_SCREEN6:
      return { ...state, cteLeftSunburstDataScreen6: action.payload };
    case ActionTypesScreen6.GET_CTE_RIGHT_SUNBURST_SCREEN6:
      return { ...state, cteRightSunburstDataScreen6: action.payload };
    case ActionTypesScreen6.GET_EDUCATION_SUMMARY_CARDS_SCREEN6:
      return { ...state, educationSummaryCardsScreen6: action.payload };
    case ActionTypesScreen6.GET_GRAD_POST_SUMMARY_SCREEN6:
      return { ...state, gradPostSummaryScreen6: action.payload };
    case ActionTypesScreen6.GET_GRAD_POST_SUBGROUP_SCREEN6:
      return { ...state, gradPostSubgroupSummaryScreen6: action.payload };
    case ActionTypesScreen6.GET_NAEP_TABLE_SCREEN6:
      return { ...state, naepTableScreen6: action.payload };
    case ActionTypesScreen6.GET_COMPLETIONS_OVER_TIME_SCREEN6:
      return { ...state, completionsOverTimeScreen6: action.payload };
    case ActionTypesScreen6.GET_COMPLETIONS_BY_DEGREE_TYPE_SCREEN6:
      return { ...state, completionsByDegreeTypeScreen6: action.payload };
    default:
      return state;
  }
}

export default Screen6Reducer;
